import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom'

const withRouter = (WrappedComponent) => {
    const HOC = (props) => {
        return (
            <Router>
                <WrappedComponent {...props} />
            </Router>
        )
    }
    return HOC;
}
export default withRouter;